import React,{ Component } from 'react';

import {
  Row,
  Col,
  Button,
  Label, 
  Input,
  InputGroup,
  InputGroupAddon,
  FormGroup 
} from 'reactstrap';

import TextInput from '../../../shared/components/TextInput';
import ColorInput from '../../../shared/components/ColorInput';
import CheckboxInput from '../../../shared/components/CheckboxInput'
import Form from '../../../shared/components/Form';
import TutorialPopover from '../../../shared/components/TutorialPopover';
import RichTextInput from '../../../shared/components/RichTextInput';

import DCMTagInput from '../../../shared/components/DCMTagInput';

import { validateTags } from '../../../shared/validators';


const URL_REGEX = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;

class CampaignConclusionForm extends Component {
  constructor(){
    super();

    this.state = {
      validationMessages:{},
      isShowingPopover:false,
      useCTA:true
    };
  }

  componentWillMount(){
    if(!this.props.activeCampaignUseCTA && this.props.activeCampaignUseCTA !== null){
      this.setState({useCTA:false});
    } else {
      this.setState({useCTA:true});
    }
  }

  componentWillReceiveProps(nextProps){
    if(!this.props.open && nextProps.open){
      window.setTimeout(() => this.setState({isShowingPopover:true}),500);
    }

    if(this.props.open && !nextProps.open){
      this.setState({isShowingPopover:false});
    }

    if(nextProps.activeCampaignUseCTA !== this.props.activeCampaignUseCTA){
      this.setState({useCTA:nextProps.activeCampaignUseCTA});
    }

    //UPDATE usCTA from props
  }

  handleSubmit(data){
    const validationMessages = {};

    if(!data.completionText || data.completionText.replace(/<\/?[^>]+(>|$)/g, "").trim().length === 0){
      validationMessages['completionText'] = 'Text is required';
    }

    if(this.state.useCTA){
      data.useCTA = true;

      if(!data.ctaLink){
        data.ctaLink = '';
      }

      if(!data.ctaText){
        data.ctaText = '';
      }

      if(!data.ctaColor){
        data.ctaColor = '';
      }

      if(!data.ctaText || data.ctaText.length === 0){
        validationMessages['ctaText'] = 'CTA text is required';
      }  

      if(!data.ctaColor || data.ctaColor.length === 0){
        validationMessages['ctaColor'] = 'CTA color is required';
      } 

      if(!data.ctaLink || data.ctaLink.length === 0){
        validationMessages['ctaLink'] = 'CTA link is required';
      } else if(!URL_REGEX.test(data.ctaLink)){
        validationMessages['ctaLink'] = 'Not a valid web address';   
      }
    } else {
      data.useCTA = false;
    }

    if(Object.keys(validationMessages).length > 0){
      this.setState({validationMessages:validationMessages});
      this.props.onSubmit(data);
    } else {
      this.setState({validationMessages:{}});
      this.props.onSubmit(data);
    }
  }

  render(){
    return (
      <Form 
        includeEmpty
        onSubmit={(data) => this.handleSubmit(data)}
      >
        <TutorialPopover
          open={this.state.isShowingPopover && this.props.isShowingTutorial}
          target='CompletionTextInput'
          onCloseClick={() => this.setState({isShowingPopover:false})}
          title='Wrap it up'
        >
          <p>
            Wrap up the experience and your conversation with your audience.
            <br /><br />
            To change the brand name and logo, edit the brand section above.
          </p>
        </TutorialPopover>
        <RichTextInput
          id='CompletionTextInput'
          label='Text'
          name='completionText'
          multiline
          defaultValue={this.props.activeCampaignCompletionText}
          placeholder='Thanks for spending time with us!'
          warning={this.state.validationMessages['completionText']}
          maxLength={180}
        />
        <CheckboxInput 
          name='useCTA'
          label='Include CTA Link'
          checked={this.state.useCTA}
          onClick={(e) => this.setState({useCTA:e.target.checked})} 
          tooltip={(
            <div>
              Link consumers to your web, e-commerce or social site to continue the conversation.<br /><br />  Call to action text examples:
              <ul>
                <li>Learn more</li>
                <li>Buy now</li>
                <li>Sign up</li>
                <li>Register</li>
              </ul>
            </div>
          )}
        />
        {this.state.useCTA && (
          <div>
            <Row>
              <Col xs='12'>
                <br />
                <TextInput 
                  label='CTA Link'
                  name='ctaLink'
                  placeholder='https://'
                  defaultValue={this.props.activeCampaignCTALink}
                  warning={this.state.validationMessages['ctaLink']}
                />
              </Col>
            </Row>
            <Row>
              <Col xs='8'>
                <TextInput 
                  label='CTA Text'
                  name='ctaText'
                  placeholder='Visit Our Site'
                  defaultValue={this.props.activeCampaignCTAText}
                  maxLength={20}
                  warning={this.state.validationMessages['ctaText']}
                />              
              </Col>
              <Col xs='4'>
                <ColorInput 
                  label='CTA Background Color'
                  name='ctaColor'
                  placeholder='#ffffff'
                  defaultValue={this.props.activeCampaignCTAColor}
                  warning={this.state.validationMessages['ctaColor']}
                />   
              </Col>
            </Row>
          </div>
        )}
        <br />
        <Button size='sm' color='primary'>
          &nbsp;&nbsp;Save&nbsp;&nbsp;
        </Button>
      </Form>
    )
  }
}

CampaignConclusionForm.defaultProps = {
  onSubmit:() => {},
  isShowingTutorial:true
};

export default CampaignConclusionForm;



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignCreation/components/CampaignConclusionForm.js